import React from 'react';

import { makeStyles } from '@material-ui/core';

import { ISearchableChecklistItem } from "../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem";

export interface ISquareLocationItem extends ISearchableChecklistItem {
    business_name: string;
    address?: {
        address_line_1?: string;
        postal_code?: string;
    },
    should_import?: boolean;
    data: object,
    errors: any[]
}

const useStyles = makeStyles({
    root: {
        
    },
    header: {
        fontWeight: 600,
    },
    body: {
        paddingRight: "0.4rem",
        fontSize: "0.8rem",
        fontWeight: 400
    },
    error: {
        display: "block",
        color: "#F65164"
    }
})

const SquareLocationItem = (props: ISquareLocationItem) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.header}>{props.business_name}</div>
            <span className={classes.body}>{
                props.address?.address_line_1 && props.address.address_line_1
            }</span>
            <span className={classes.body}>{
                props.address?.postal_code && props.address.postal_code
            }</span>
            {props.errors.map((error: any) => {
                return (<span className={`${classes.body} ${classes.error}`}>{error.error}</span>)
            })}
        </div>
    )
}

export default SquareLocationItem;